<div class="d-flex flex-row flex-wrap justify-content-center align-items-center text-center shop-by-brand">
  <div *ngIf="!brands">
    <img [src]="settings?.holdingImage?.medium" style="max-width: 250px; width:100%" alt="Brands Waiting" />
  </div>
  <div *ngFor="let brand of brands" class="flex-auto brand-link">
    <a *ngIf="brand.pictureUrl" [routerLink]="['/manufacturers', brand.seName]" routerLinkActive="router-link-active" class="text-center w-100">
      <img [src]="brand.pictureUrl" [alt]="brand.name">
      <div class="menu-logo-caption">{{brand.name}}</div>
    </a>
  </div>
</div>
